module.exports = __webpack_public_path__ + "img/logo-dark.53eb7251.png";